import { NavLink, Outlet } from 'react-router-dom';

/**
 * AccountLayout — ROUND7 P4 Account hub wrapper.
 *
 * Única excepción del "no sidebar" del Header per Tech Lead: dentro de
 * /account/* renderea sidebar vertical admin-style a la izquierda
 * (sticky on md+) y `<Outlet />` con el contenido de la sub-ruta a la
 * derecha. Wrapped en `<RequireAuth>` desde routes/index.tsx.
 */
type AccountLink = { to: string; label: string; end?: boolean };

const LINKS: ReadonlyArray<AccountLink> = [
  { to: '/account', label: 'Dashboard', end: true },
  { to: '/account/profile', label: 'Perfil' },
  { to: '/account/payment-methods', label: 'Métodos de pago' },
  { to: '/account/membership', label: 'Mi membresía' },
  { to: '/account/notifications', label: 'Notificaciones' },
];

export function AccountLayout(): JSX.Element {
  return (
    <section className="container-fc py-8 md:py-12">
      <header className="mb-6">
        <h1 className="font-display text-3xl md:text-4xl">Mi cuenta</h1>
        <p className="mt-1 text-sm text-fc-muted">
          Gestioná tu perfil, métodos de pago, membresía y preferencias.
        </p>
      </header>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-[220px_1fr]">
        <nav aria-label="Cuenta navigation" className="md:sticky md:top-20 md:self-start">
          <ul className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  end={l.end}
                  className={({ isActive }) =>
                    [
                      'block rounded-card px-3 py-2 text-sm transition-colors',
                      'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
                      isActive
                        ? 'bg-primary-50 font-medium text-primary-600'
                        : 'text-neutral-700 hover:bg-neutral-50 hover:text-neutral-900',
                    ].join(' ')
                  }
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <main>
          <Outlet />
        </main>
      </div>
    </section>
  );
}
